import { Component, OnInit, Input } from '@angular/core';
import { Card,CardType } from './Card';
@Component({
  selector: 'vias-info-card',
  templateUrl: './info-card.component.html',
  styleUrls: ['./info-card.component.scss']
})
export class InfoCardComponent implements OnInit {

  @Input() card: Card ;
  constructor() { }

  ngOnInit(): void {
  }

}
